import React from "react";
import { ChipProps } from "@mui/material";

import { ExternalChip, GuestChip, MemberChip } from "./AccountBox.styles";

interface AccountTypeChipProps extends Omit<ChipProps, "label"> {
  External: boolean;
  Role?: string;
}

const AccountTypeChip: React.FC<AccountTypeChipProps> = ({ External, Role, ...chipProps }) => {
  if (External) {
    return <ExternalChip label="External" data-testid="external-chip" {...chipProps} />;
  }
  if (Role === "guest") {
    return <GuestChip label="Guest" data-testid="guest-chip" {...chipProps} />;
  }
  return <MemberChip label="Member" data-testid="member-chip" {...chipProps} />;
};

export default AccountTypeChip;
